import React, { useRef } from 'react';

// 6-box code input. Handles typing, paste and phone autofill ("from Messages"/
// "from Mail"), which drops the whole code into one box at once.
export const OtpInput = ({ value, onChange, testid, boxTestid = 'otp', onComplete }) => {
  const refs = useRef([]);
  const chars = (value || '').padEnd(6, ' ').slice(0, 6).split('');

  const put = (idx, raw) => {
    const digits = (raw || '').replace(/\D/g, '');
    const arr = chars.slice();
    if (!digits) arr[idx] = ' ';
    else if (digits.length === 1) arr[idx] = digits;
    else digits.slice(0, 6 - (digits.length >= 6 ? 0 : idx)).split('')
      .forEach((d, i) => { const at = (digits.length >= 6 ? 0 : idx) + i; if (at < 6) arr[at] = d; });
    const next = arr.join('').replace(/ /g, '');
    onChange(next);
    const filled = arr.findIndex((c) => c === ' ');
    refs.current[filled === -1 ? 5 : filled]?.focus();
    if (next.length === 6) onComplete?.(next);
  };
  const handleKey = (idx, e) => {
    if (e.key === 'Backspace' && !chars[idx].trim() && idx > 0) refs.current[idx - 1]?.focus();
    if (e.key === 'ArrowLeft' && idx > 0) refs.current[idx - 1]?.focus();
    if (e.key === 'ArrowRight' && idx < 5) refs.current[idx + 1]?.focus();
  };
  const handlePaste = (idx, e) => {
    const text = e.clipboardData?.getData('text') || '';
    if (text.replace(/\D/g, '')) { e.preventDefault(); put(idx, text); }
  };

  return (
    <div className="grid grid-cols-6 gap-2 sm:gap-3" data-testid={testid}>
      {chars.map((ch, idx) => (
        <input
          key={`otp-${idx}`}
          ref={(el) => (refs.current[idx] = el)}
          type="text" inputMode="numeric" pattern="[0-9]*" autoComplete={idx === 0 ? 'one-time-code' : 'off'}
          value={ch.trim()}
          onChange={(e) => {
            const v = e.target.value.replace(/\D/g, '');
            // Typing over a filled box: keep only the newly typed digit.
            put(idx, v.length === 2 && ch.trim() ? v.replace(ch.trim(), '') || v.slice(-1) : v);
          }}
          onFocus={(e) => e.target.select()}
          onKeyDown={(e) => handleKey(idx, e)} onPaste={(e) => handlePaste(idx, e)}
          aria-label={`Digit ${idx + 1}`}
          className="w-full bg-slate-900/60 border border-white/15 text-white text-center text-xl sm:text-2xl font-semibold rounded-lg h-12 sm:h-14 outline-none focus:ring-2 focus:ring-teal-400"
          data-testid={`${boxTestid}-${idx}`}
        />
      ))}
    </div>
  );
};
